import { Story } from '../types';

export const toStoryDTO = (story: any): Story => ({
  ...story,
  name: `${story.firstname} ${story.lastname}`,
  isPublished: story.published?.some((value: string) => value !== 'null')
});
